import { Modal, Box, Typography, IconButton } from '@mui/material'
import ButtonCustom from '../button/ButtonCustom'
import styles from './DeleteModal.module.scss'

const DeleteConfirmationModal = ({
	open,
	onClose,
	onDelete,
	title = 'Delete Time Off Request',
	message = 'Are you sure you want to delete this time off request? This action cannot be undone.',
	confirmText = 'Delete',
	cancelText = 'Cancel'
}) => {
	return (
		<Modal
			open={open}
			onClose={onClose}
			aria-labelledby="delete-modal-title"
			aria-describedby="delete-modal-desc"
			className={styles.backdrop}
		>
			<Box className={styles.modal} role="dialog" aria-modal="true">
				<IconButton
					aria-label="close"
					className={styles.closeBtn}
					onClick={onClose}
					size="large"
				>
					<img src="/images/modal-close-icon.svg" alt="close" />
				</IconButton>

				<div className={styles.iconCircle} aria-hidden>
					<img src="/images/trash-red.svg" alt="delete" />
				</div>

				<h3 id="delete-modal-title" className={styles.title}>
					{title}
				</h3>

				<Typography id="delete-modal-desc" className={styles.subtitle}>
					{message}
				</Typography>

				<Box className={styles.footer}>
					<ButtonCustom
						variant="outlined"
						size="md"
						onClick={onClose}
					>
						{cancelText}
					</ButtonCustom>

					<ButtonCustom
						variant="destructive"
						size="md"
						onClick={onDelete}
						data-cy="delete-button"
					>
						{confirmText}
					</ButtonCustom>
				</Box>
			</Box>
		</Modal>
	)
}

export default DeleteConfirmationModal